const {Emoji, emojiIndex} = require('emoji-mart');

let emoticons = emojiIndex.emoticons;
let emoticons_list = Object.keys(emoticons);

emoticons_list.forEach((item, index) => {
	let frags = item.split('');
	if(frags.length > 0){
		for(let frag_index in frags){
			let frag = frags[frag_index];
			if(frag === '\\'){
				frags[frag_index] = '\\\\';
			}
			let illegal_chars = [')', '(', '$', '|', '*','-',']','[', '/'];
			if (illegal_chars.indexOf(frag) !== -1){
				frags[frag_index] = "\\"+frag;
			}

		}
	}
    emoticons_list[index] = '[' + frags.join('][') + ']';
});

let negative_lookahead = '(?!(([a-zA-Z0-9_:-])*[~]))';
let regex = new RegExp('(' + emoticons_list.join(negative_lookahead + ')|(') + negative_lookahead + ')', 'g');

function renderEmoji(text, skip_emoticons = false) {
    if (skip_emoticons === false) {
    	text = replaceShort(text);
    }

    let found = findEmoji(text);

    if (!found) return text;

    found.forEach(name => {
        let emoji = getEmoji(name.substring(2, name.length - 2));
        text = text.replace(name, emoji);
    });

    return text;
}

function replaceShort(text, positionChange = null) {
    let match;
	while ((match = regex.exec(text)) != null) {
		if (positionChange !== null) {
		    //The new emoji takes up a length of 1 + 1 space
            //So the change in position will be the length of the written match subtracted 2
			positionChange.value -= (match[0].length - 2);
		}

		let first_part = text.substr(0, match.index);
		let last_part = text.substr(match.index + match[0].length + 1);
		let name = emoticons[match[0]];
		text = first_part + '~:' + name + ':~' + last_part;
	}

	return text;
}

function getEmoji(emoji) {

    let e = Emoji({
        html: false,
        set: 'emojione',
        emoji: emoji,
        size: 22,
    });

    if (e === null) {
        return '';
    }

    let img = document.createElement('img');

    img.setAttribute('src', 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
    //img.setAttribute('contenteditable', 'false');
    img.setAttribute('data-emoji', emoji);

    let styles = e.props.children.props.style;

    for (let style_index in styles) {
        let suffix = '';
        if (style_index === 'width' || style_index === 'height') {
            suffix = 'px';
        }
        img.style[style_index] = styles[style_index] + suffix;
    }

    img.style.verticalAlign = 'bottom';


    return img.outerHTML+' ';
    return '<span contenteditable="false" data-emoji="' + emoji + '">' + img.outerHTML + '</span>';
    return '<span contenteditable="false"></span><span contenteditable="false" data-emoji="' + emoji + '">' + img.outerHTML + '</span><span contenteditable="false"></span>';
    //return img.outerHTML;
}

function findEmoji(text) {
    return text.match(/~:([a-z_+0-9\-]*):~/gm)
}

module.exports = {
	renderEmoji,
	replaceShort
};



// WEBPACK FOOTER //
// ./resources/js/helpers/renderEmoji.js